<template>
  <div class="appBread">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }" v-if="activeIndex == '/home'">首页</el-breadcrumb-item>
      <template v-for="(item, index) in breadcrumbs">
        <el-breadcrumb-item :to="{ path: item.path }" :key="index">
          <span>{{item.title}}</span>
        </el-breadcrumb-item>
      </template>
    </el-breadcrumb>
  </div>
</template>

<script>
  export default {
    name: 'AppBread',
    computed: {
      breadcrumbs () {
        const crumbs = [];
        for (let i = 0; i < this.$route.matched.length; i++) {
          const route = this.$route.matched[i];
          
          if (!route.meta || !route.meta.title || route.path === '/home') {
            continue;
          }
          crumbs.push({
            title: route.meta.title,
            path: route.path
          });
        }
        
        return crumbs;
      },
      activeIndex () {
        return this.$route.path;
      }
    }
  };
</script>

<style lang="scss">
  @import "@/styles/_variables.scss";
  
  .appBread .el-breadcrumb {
    line-height: $breadH;
    margin-left: 20px;
  }

</style>
